/* ==========================================================================
   MOODMUM® — Dönüşüm Teması / theme.js
   Bağımlılık yok. Tüm modüller kendi elemanları sayfada yoksa sessizce çıkar.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.MoodmumTheme || {};
  T.routes = T.routes || {};

  /* ------------------------------------------------------------ yardımcılar */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function on(el, evt, fn, opts) {
    if (el) el.addEventListener(evt, fn, opts);
  }

  function parseJSON(str, fallback) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  }

  /**
   * Shopify money_format desenini uygular.
   * Desteklenen: amount, amount_no_decimals, amount_with_comma_separator,
   * amount_no_decimals_with_comma_separator, amount_with_apostrophe_separator
   */
  function formatMoney(cents, format) {
    var fmt = format || T.moneyFormat || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    var name = match ? match[1] : 'amount';

    function pad(num, size) {
      var s = String(num);
      while (s.length < size) s = '0' + s;
      return s;
    }

    function build(precision, thousands, decimal) {
      var num = (cents / 100.0).toFixed(precision);
      var parts = num.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + pad(parts[1], precision) : '';
      return intPart + decPart;
    }

    switch (name) {
      case 'amount':
        value = build(2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = build(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = build(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = build(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = build(2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = build(0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = build(2, ' ', ',');
        break;
      default:
        value = build(2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  /** Metni yazar; gerçekten değiştiyse kısa bir vurgu animasyonu tetikler. */
  function setText(el, value) {
    if (!el || el.textContent === value) return;
    el.textContent = value;
    if (document.body.dataset.anim === 'off') return;
    el.classList.remove('price-flash');
    void el.offsetWidth; // reflow — animasyonu yeniden başlatmak için
    el.classList.add('price-flash');
  }

  /** Buton durumu: null | 'loading' | 'done' */
  function setButtonState(btn, state) {
    if (!btn) return;
    btn.classList.remove('is-loading', 'is-done');
    if (state) btn.classList.add('is-' + state);
    if (state === 'loading') btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
  }

  function toast(message) {
    var root = $('#ToastRoot');
    if (!root) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    root.appendChild(el);
    setTimeout(function () {
      el.remove();
    }, 3200);
  }

  /* --------------------------------------------------- 1. Scroll reveal */

  function initReveal() {
    if (document.body.classList.contains('animations-off')) return;
    var items = $$('.reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // Aynı ebeveyni paylaşan kardeşlere kademe indeksi ver → sırayla belirsinler
    var seen = new Map();
    items.forEach(function (el) {
      if (el.style.getPropertyValue('--i')) return;
      var parent = el.parentElement;
      var n = seen.get(parent) || 0;
      if (n < 6) el.style.setProperty('--i', n);
      seen.set(parent, n + 1);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });

    // Güvenlik ağı: 4 sn sonra hâlâ gizli kalan varsa zorla göster.
    setTimeout(function () {
      $$('.reveal:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-visible');
      });
    }, 4000);
  }

  /* ----------------------------------------------------- 2. Mobil menü */

  function initMenu() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('[data-mobile-nav]');
    if (!toggle || !nav) return;
    on(toggle, 'click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* -------------------------------------------------- 3. Sepet çekmecesi */

  var CartDrawer = {
    el: null,
    lastFocus: null,

    init: function () {
      this.el = $('[data-cart-drawer]');
      if (!this.el) return;
      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener) {
          e.preventDefault();
          self.open();
          return;
        }
        if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          self.close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });

      this.bindLines();
    },

    bindLines: function () {
      var self = this;
      if (this._bound) return;
      this._bound = true;

      document.addEventListener('click', function (e) {
        var remove = e.target.closest('[data-line-remove]');
        if (remove) {
          e.preventDefault();
          self.change(remove.getAttribute('data-line'), 0);
          return;
        }
        var step = e.target.closest('[data-qty-step]');
        if (step) {
          e.preventDefault();
          var wrap = step.closest('[data-qty]');
          var input = $('input', wrap);
          var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
          if (next < 0) next = 0;
          input.value = next;
          self.change(wrap.getAttribute('data-line'), next);
        }
      });

      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty] input');
        if (!input) return;
        var wrap = input.closest('[data-qty]');
        self.change(wrap.getAttribute('data-line'), parseInt(input.value, 10) || 0);
      });
    },

    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = $('[data-cart-close]', this.el);
      if (close) close.focus();
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    },

    change: function (line, quantity) {
      var self = this;
      fetch(T.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          return self.refresh();
        })
        .catch(function () {
          toast(T.strings ? T.strings.addToCartError : 'Bir hata oluştu');
        });
    },

    refresh: function () {
      var self = this;
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-drawer]', doc);
          var current = $('[data-cart-drawer]');
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
            self.el = current;
            self.stagger();
          }
          self.syncCount(doc);
        });
    },

    syncCount: function (doc) {
      var source = $('[data-cart-count]', doc || document);
      var badge = $('header [data-cart-count]');
      if (!badge) return;
      var count = source ? source.getAttribute('data-cart-count') : null;
      if (count === null) return;
      var changed = badge.textContent.trim() !== String(count).trim();
      badge.textContent = count;
      badge.setAttribute('data-cart-count', count);
      badge.hidden = parseInt(count, 10) === 0;
      if (changed && !badge.hidden && document.body.dataset.anim !== 'off') {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      }
    },

    /** Çekmecedeki satırlara kademe indeksi verir (sırayla kaysınlar) */
    stagger: function () {
      $$('.cart-line', this.el).forEach(function (line, i) {
        line.style.setProperty('--i', Math.min(i, 8));
      });
    }
  };

  /* ------------------------------------------------ 4. Sepete ekleme API */

  function addToCart(items, options) {
    options = options || {};
    return fetch(T.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'error');
          return body;
        });
      })
      .then(function () {
        if (options.discountCode) {
          window.location.href =
            '/discount/' + encodeURIComponent(options.discountCode) + '?redirect=' + encodeURIComponent(T.routes.cart_url);
          return;
        }
        var mode = options.cartType || 'drawer';
        if (mode === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        if (mode === 'page') {
          window.location.href = T.routes.cart_url;
          return;
        }
        return CartDrawer.refresh().then(function () {
          CartDrawer.open();
        });
      });
  }

  /* ------------------------------------------------------- 5. Ürün galerisi */

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ktBound === '1') return;
      gallery.dataset.ktBound = '1';
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var dots = $$('[data-gallery-dot]', gallery);
      if (slides.length < 1) return;
      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
        });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === index);
          t.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
          d.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (t, n) {
        on(t, 'click', function () {
          show(n);
        });
      });

      dots.forEach(function (d, n) {
        on(d, 'click', function () {
          show(n);
        });
      });

      on($('[data-gallery-prev]', gallery), 'click', function () {
        show(index - 1);
      });
      on($('[data-gallery-next]', gallery), 'click', function () {
        show(index + 1);
      });

      // Dokunmatik kaydırma
      var startX = null;
      var main = $('[data-gallery-main]', gallery);
      on(main, 'touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      on(main, 'touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(dx < 0 ? index + 1 : index - 1);
        startX = null;
      });

      gallery.showMediaById = function (mediaId) {
        var target = slides.findIndex(function (s) {
          return s.getAttribute('data-media-id') === String(mediaId);
        });
        if (target > -1) show(target);
      };

      show(0);
    });
  }

  /* ------------------------------------------------------ 6. Paket seçici */

  function BundleForm(root) {
    var self = this;
    this.root = root;
    this.variants = parseJSON(($('[data-variants-json]', root) || {}).textContent, []) || [];
    this.cartType = root.getAttribute('data-cart-type') || 'drawer';
    this.bundles = $$('[data-bundle]', root);
    this.button = $('[data-atc]', root);
    this.stickyButton = $('[data-sticky-atc-button]');
    this.gallery = $('[data-gallery]', root.closest('.product') || document);

    this.bundles.forEach(function (bundle) {
      on($('input[type="radio"]', bundle), 'change', function () {
        self.select(bundle);
      });
      $$('[data-unit-option]', bundle).forEach(function (control) {
        var evt = control.tagName === 'SELECT' ? 'change' : 'click';
        on(control, evt, function () {
          if (evt === 'click') {
            var group = control.closest('[data-unit]');
            $$('[data-unit-option]', group).forEach(function (b) {
              b.classList.remove('is-active');
              b.setAttribute('aria-checked', 'false');
            });
            control.classList.add('is-active');
            control.setAttribute('aria-checked', 'true');
            var hidden = $('[data-unit-value]', group);
            if (hidden) hidden.value = control.getAttribute('data-variant-id');
            var labelValue = $('[data-unit-label-value]', group);
            if (labelValue) labelValue.textContent = control.getAttribute('data-variant-title') || '';
            var thumb = $('[data-unit-thumb]', group);
            var img = control.getAttribute('data-variant-image');
            if (thumb && img) thumb.src = img;
          }
          self.updatePrices();
        });
      });
    });

    on(this.button, 'click', function (e) {
      e.preventDefault();
      self.submit();
    });
    on(this.stickyButton, 'click', function (e) {
      e.preventDefault();
      self.submit();
    });

    var preselected = this.bundles.filter(function (b) {
      return $('input[type="radio"]', b).checked;
    })[0];
    this.select(preselected || this.bundles[0]);
  }

  BundleForm.prototype.select = function (bundle) {
    if (!bundle) return;
    this.bundles.forEach(function (b) {
      b.classList.toggle('is-selected', b === bundle);
    });
    var radio = $('input[type="radio"]', bundle);
    if (radio) radio.checked = true;
    this.current = bundle;
    this.updatePrices();
  };

  BundleForm.prototype.variantById = function (id) {
    var found = null;
    this.variants.forEach(function (v) {
      if (String(v.id) === String(id)) found = v;
    });
    return found;
  };

  BundleForm.prototype.unitVariantIds = function (bundle) {
    var ids = [];
    $$('[data-unit]', bundle).forEach(function (unit) {
      var hidden = $('[data-unit-value]', unit);
      if (hidden && hidden.value) ids.push(hidden.value);
    });
    if (!ids.length) {
      var qty = parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
      var fallback = bundle.getAttribute('data-default-variant');
      for (var i = 0; i < qty; i++) ids.push(fallback);
    }
    return ids;
  };

  BundleForm.prototype.updatePrices = function () {
    var self = this;
    this.bundles.forEach(function (bundle) {
      var discount = parseFloat(bundle.getAttribute('data-discount')) || 0;
      var ids = self.unitVariantIds(bundle);
      var subtotal = 0;
      var compareTotal = 0;
      ids.forEach(function (id) {
        var v = self.variantById(id);
        if (!v) return;
        subtotal += v.price;
        compareTotal += v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
      });
      // Liquid ile birebir aynı hesap: indirim tutarı aşağı yuvarlanır, sonra
      // ara toplamdan düşülür. Aksi hâlde sunucunun bastığı fiyatla JS'in
      // güncellediği fiyat 1 kuruş ayrışabilir.
      var total = subtotal - Math.floor((subtotal * discount) / 100);
      var qty = parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
      var saving = compareTotal - total;

      setText($('[data-bundle-price]', bundle), formatMoney(total));
      setText($('[data-bundle-unit-price]', bundle), formatMoney(Math.floor(total / qty)));

      var compareEl = $('[data-bundle-compare]', bundle);
      if (compareEl) {
        if (compareTotal > total) {
          compareEl.textContent = formatMoney(compareTotal);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      var savingEl = $('[data-bundle-saving]', bundle);
      if (savingEl) {
        if (saving > 0) {
          setText($('[data-bundle-saving-value]', bundle), formatMoney(saving));
          savingEl.hidden = false;
        } else {
          savingEl.hidden = true;
        }
      }

      bundle.setAttribute('data-total', total);
      bundle.setAttribute('data-compare-total', compareTotal);
    });

    if (this.current) {
      var total = parseInt(this.current.getAttribute('data-total'), 10) || 0;
      var compareTotal = parseInt(this.current.getAttribute('data-compare-total'), 10) || 0;
      var saving = compareTotal - total;

      // Sabit alt bar: seçili paketin adı, fiyatı ve üstü çizili tutarı
      setText($('[data-sticky-atc-price]'), formatMoney(total));
      var stickyLabel = $('[data-sticky-atc-label]');
      var tierName = ($('.bundle__qty', this.current) || {}).textContent;
      if (stickyLabel && tierName) stickyLabel.textContent = tierName.trim();

      var stickyCompare = $('[data-sticky-atc-compare]');
      if (stickyCompare) {
        if (saving > 0) {
          stickyCompare.textContent = formatMoney(compareTotal);
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }

      // Sepete ekle üstündeki tasarruf satırı
      var savingsBox = $('[data-atc-savings]', this.root);
      if (savingsBox) {
        if (saving > 0 && T.strings.savingsLine) {
          savingsBox.textContent = T.strings.savingsLine.replace(
            /__AMOUNT__|\{\{\s*amount\s*\}\}/,
            formatMoney(saving)
          );
          savingsBox.hidden = false;
        } else {
          savingsBox.hidden = true;
        }
      }

      var firstId = this.unitVariantIds(this.current)[0];
      var v = this.variantById(firstId);
      if (v && this.gallery && this.gallery.showMediaById && v.featured_media_id) {
        this.gallery.showMediaById(v.featured_media_id);
      }
      var idInput = $('[data-selected-variant-id]', this.root);
      if (idInput && firstId) idInput.value = firstId;
    }
  };

  BundleForm.prototype.submit = function () {
    var self = this;
    var bundle = this.current;
    if (!bundle) return;

    var counts = {};
    this.unitVariantIds(bundle).forEach(function (id) {
      if (!id) return;
      counts[id] = (counts[id] || 0) + 1;
    });

    var items = Object.keys(counts).map(function (id) {
      return { id: parseInt(id, 10), quantity: counts[id] };
    });

    if (!items.length) {
      toast(T.strings.unavailable);
      return;
    }

    var gifts = parseJSON(bundle.getAttribute('data-gifts'), []) || [];
    gifts.forEach(function (gift) {
      if (!gift.id) return;
      items.push({
        id: parseInt(gift.id, 10),
        quantity: parseInt(gift.quantity, 10) || 1,
        properties: { _hediye: 'true' }
      });
    });

    var buttons = [this.button, this.stickyButton].filter(Boolean);
    if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return;

    buttons.forEach(function (b) {
      setButtonState(b, 'loading');
    });

    var failed = false;
    addToCart(items, {
      cartType: this.cartType,
      discountCode: bundle.getAttribute('data-discount-code') || ''
    })
      .catch(function (err) {
        failed = true;
        toast(err.message || T.strings.addToCartError);
      })
      .then(function () {
        if (failed) {
          buttons.forEach(function (b) { setButtonState(b, null); });
          return;
        }
        // Kısa "eklendi" onayı, sonra normale dön
        buttons.forEach(function (b) { setButtonState(b, 'done'); });
        setTimeout(function () {
          buttons.forEach(function (b) { setButtonState(b, null); });
        }, 1500);
        self.updatePrices();
      });
  };

  function initBundles() {
    $$('[data-bundle-form]').forEach(function (root) {
      // Theme editor bölümü yeniden yüklediğinde iki kez bağlanmayı önler
      if (root.dataset.ktBound === '1') return;
      root.dataset.ktBound = '1';
      new BundleForm(root);
    });
  }

  /* ----------------------------------- 7. Basit varyant seçici (paketsiz) */

  function initSimpleProductForm() {
    $$('[data-simple-form]').forEach(function (root) {
      if (root.dataset.ktBound === '1') return;
      root.dataset.ktBound = '1';
      var variants = parseJSON(($('[data-variants-json]', root) || {}).textContent, []) || [];
      var cartType = root.getAttribute('data-cart-type') || 'drawer';
      var button = $('[data-atc]', root);
      var stickyButton = $('[data-sticky-atc-button]');
      var priceEl = $('[data-price-current]', root);
      var compareEl = $('[data-price-compare]', root);
      var idInput = $('[data-selected-variant-id]', root);
      var qtyInput = $('[data-product-quantity]', root);
      var gallery = $('[data-gallery]', root.closest('.product') || document);

      function currentOptions() {
        return $$('fieldset', root).map(function (fs) {
          var checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
      }

      function match() {
        var opts = currentOptions();
        var found = null;
        variants.forEach(function (v) {
          var ok = true;
          opts.forEach(function (o, i) {
            if (o !== null && v.options[i] !== o) ok = false;
          });
          if (ok && !found) found = v;
        });
        return found;
      }

      // Buton yazısı .btn__label içine yazılır; spinner/onay ikonları korunur
      var buttonLabel = button ? $('[data-atc-label]', button) || button : null;

      function update() {
        var v = match();
        if (!v) {
          if (button) {
            button.setAttribute('aria-disabled', 'true');
            buttonLabel.textContent = T.strings.unavailable;
          }
          return;
        }
        if (idInput) idInput.value = v.id;
        setText(priceEl, formatMoney(v.price));
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        setText($('[data-sticky-atc-price]'), formatMoney(v.price));
        var stickyCompare = $('[data-sticky-atc-compare]');
        if (stickyCompare) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            stickyCompare.textContent = formatMoney(v.compare_at_price);
            stickyCompare.hidden = false;
          } else {
            stickyCompare.hidden = true;
          }
        }
        if (gallery && gallery.showMediaById && v.featured_media_id) gallery.showMediaById(v.featured_media_id);
        if (button) {
          if (v.available) {
            button.removeAttribute('aria-disabled');
            buttonLabel.textContent = button.getAttribute('data-label') || 'SEPETE EKLE';
          } else {
            button.setAttribute('aria-disabled', 'true');
            buttonLabel.textContent = T.strings.soldOut;
          }
        }
      }

      $$('input[type="radio"]', root).forEach(function (input) {
        on(input, 'change', update);
      });

      function submit(e) {
        e.preventDefault();
        var v = match();
        if (!v || !v.available) return;

        var buttons = [button, stickyButton].filter(Boolean);
        if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return;

        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        buttons.forEach(function (b) { setButtonState(b, 'loading'); });

        var failed = false;
        addToCart([{ id: v.id, quantity: qty }], { cartType: cartType })
          .catch(function (err) {
            failed = true;
            toast(err.message || T.strings.addToCartError);
          })
          .then(function () {
            if (failed) {
              buttons.forEach(function (b) { setButtonState(b, null); });
              return;
            }
            buttons.forEach(function (b) { setButtonState(b, 'done'); });
            setTimeout(function () {
              buttons.forEach(function (b) { setButtonState(b, null); });
            }, 1500);
          });
      }

      on(button, 'click', submit);
      on(stickyButton, 'click', submit);
      update();
    });
  }

  /* ------------------------------------------------- 8. Sabit ATC (mobil) */

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc]');
    if (!bar || !anchor) return;

    /*
      Bar sayfanın altına sabitlendiği için alt bilgideki telif satırını ve
      künyeyi örter. Yüksekliğini ölçüp --sticky-atc-h olarak yayınlıyoruz;
      base.css bunu alt bilginin alt boşluğuna ekliyor. Sabit bir değer
      yazmıyoruz: bar dar ekranda ve fiyat satırı iki satıra kırıldığında
      farklı yükseklikte oluyor. Masaüstünde bar display:none → 0px.
    */
    var setBarHeight = function () {
      var h = bar.offsetHeight || 0;
      document.documentElement.style.setProperty('--sticky-atc-h', h + 'px');
    };
    setBarHeight();
    if ('ResizeObserver' in window) {
      new ResizeObserver(setBarHeight).observe(bar);
    } else {
      window.addEventListener('resize', setBarHeight);
    }

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Ana buton ekrandayken sabit barı gizle
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  /* ---------------------------------------------- 9. Canlı izleyici sayacı */

  function initLiveViewers() {
    $$('[data-live-viewers]').forEach(function (el) {
      if (el.dataset.ktBound === '1') return;
      el.dataset.ktBound = '1';
      var min = parseInt(el.getAttribute('data-min'), 10) || 8;
      var max = parseInt(el.getAttribute('data-max'), 10) || 16;
      var target = $('[data-live-count]', el);
      if (!target) return;
      /*
        Sayı yalnızca sayfa açılırken bir kez belirlenir. Ekranda dururken
        değişmesi göze batıyor ve uydurma olduğunu ele veriyordu; sabit
        kalması hem daha inandırıcı hem de okurken dikkat dağıtmıyor.
      */
      target.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
    });
  }

  /* ------------------------------------------------- 10. Gerçek geri sayım */

  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.ktBound === '1') return;
      el.dataset.ktBound = '1';
      var target = $('[data-countdown-time]', el);
      if (!target) return;
      var deadline;
      var fixed = el.getAttribute('data-deadline');
      var hours = parseInt(el.getAttribute('data-hours'), 10) || 0;

      if (fixed) {
        deadline = new Date(fixed).getTime();
      } else if (hours > 0) {
        // Ziyaretçi başına yenilenen sayaç (localStorage)
        var key = 'kt-countdown-' + (el.getAttribute('data-key') || 'default');
        var saved = null;
        try {
          saved = localStorage.getItem(key);
        } catch (e) {}
        if (saved && parseInt(saved, 10) > Date.now()) {
          deadline = parseInt(saved, 10);
        } else {
          deadline = Date.now() + hours * 3600 * 1000;
          try {
            localStorage.setItem(key, deadline);
          } catch (e) {}
        }
      } else {
        el.hidden = true;
        return;
      }

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        target.textContent = (d > 0 ? d + 'g ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      }

      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ----------------------------------------------- 11. Öncesi/sonrası kaydırıcı */

  function initBeforeAfter() {
    $$('[data-before-after]').forEach(function (el) {
      if (el.dataset.ktBound === '1') return;
      el.dataset.ktBound = '1';
      var range = $('[data-ba-range]', el);
      if (!range) return;
      function apply() {
        el.style.setProperty('--ba-pos', range.value + '%');
      }
      on(range, 'input', apply);
      apply();
    });
  }

  /* ------------------------------------------------ 12. Mini yorum karuseli */

  function initMiniReviews() {
    $$('[data-mini-reviews]').forEach(function (el) {
      if (el.dataset.ktBound === '1') return;
      el.dataset.ktBound = '1';
      var slides = $$('[data-mini-slide]', el);
      if (slides.length < 2) return;
      var i = 0;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
        });
      }
      on($('[data-mini-prev]', el), 'click', function () {
        show(i - 1);
      });
      on($('[data-mini-next]', el), 'click', function () {
        show(i + 1);
      });
      show(0);
    });
  }

  /* ------------------------------------------------- 13. Koleksiyon sıralama */

  function initCollectionSort() {
    var select = $('[data-sort-by]');
    if (!select) return;
    on(select, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------- 14. Başlık kaydırma durumu */

  function initHeaderScroll() {
    var header = $('.header-wrapper');
    if (!header) return;
    var ticking = false;
    function apply() {
      header.classList.toggle('is-stuck', window.scrollY > 24);
      ticking = false;
    }
    on(
      window,
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      },
      { passive: true }
    );
    apply();
  }

  /* ------------------------------------------------ 15. Görsel iskeletleri */

  function initSkeletons() {
    $$('.gallery__main img, .card__media img').forEach(function (img) {
      var holder = img.parentElement;
      if (!holder || holder.classList.contains('skeleton')) return;
      if (img.complete && img.naturalWidth > 0) return;
      holder.classList.add('skeleton');
      function done() {
        holder.classList.add('is-loaded');
      }
      on(img, 'load', done);
      on(img, 'error', done);
    });
  }

  /* ------------------------------------------- 16. Teslimat tarihi tahmini */

  var TR_DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  var TR_MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
                   'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function initDeliveryEstimate() {
    $$('[data-delivery]').forEach(function (el) {
      var headline = $('[data-delivery-headline]', el);
      if (!headline) return;

      // Son sipariş saati "SS:DD" biçiminde; dakika hassasiyeti önemli (17:30)
      var cutoffRaw = el.getAttribute('data-cutoff') || '17:30';
      var cm = /^\s*(\d{1,2})[:.](\d{2})\s*$/.exec(cutoffRaw);
      var cutoffH = cm ? parseInt(cm[1], 10) : 17;
      var cutoffM = cm ? parseInt(cm[2], 10) : 30;

      var days = parseInt(el.getAttribute('data-days'), 10) || 2;

      var now = new Date();
      var start = new Date(now.getTime());
      // Sipariş saatini geçtiyse kargo bir sonraki iş günü çıkar → teslimat 1 gün öteler
      var pastCutoff =
        now.getHours() > cutoffH ||
        (now.getHours() === cutoffH && now.getMinutes() >= cutoffM);
      if (pastCutoff) start.setDate(start.getDate() + 1);
      while (start.getDay() === 0 || start.getDay() === 6) start.setDate(start.getDate() + 1);

      var arrival = addBusinessDays(start, days);
      var dateText = arrival.getDate() + ' ' + TR_MONTHS[arrival.getMonth()] + ' ' + TR_DAYS[arrival.getDay()];

      var tpl = el.getAttribute('data-template') || '{date} günü kapınızda';
      headline.textContent = tpl.replace('{date}', dateText);
    });
  }

  /* ------------------------------------------------- 17. Görsel büyütme */

  function initLightbox() {
    var box = $('[data-lightbox]');
    if (!box) return;
    var img = $('[data-lightbox-img]', box);
    var lastFocus = null;

    function open(src, alt) {
      lastFocus = document.activeElement;
      img.src = src;
      img.alt = alt || '';
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        box.classList.add('is-open');
      });
      var close = $('[data-lightbox-close]', box);
      if (close) close.focus();
    }

    function close() {
      box.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        box.hidden = true;
        img.src = '';
      }, 220);
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var zoomable = e.target.closest('.gallery__slide.is-active img');
      if (zoomable) {
        open(zoomable.currentSrc || zoomable.src, zoomable.alt);
        return;
      }
      if (e.target.closest('[data-lightbox-close]') || e.target === box) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  /* ------------------------------------------------ 18. Hızlı sepete ekleme */

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      var id = parseInt(btn.getAttribute('data-quick-add'), 10);
      if (!id) return;

      var wrap = btn.closest('[data-cart-type]');
      var mode = wrap ? wrap.getAttribute('data-cart-type') : 'drawer';

      setButtonState(btn, 'loading');
      var failed = false;
      addToCart([{ id: id, quantity: 1 }], { cartType: mode })
        .catch(function (err) {
          failed = true;
          toast(err.message || T.strings.addToCartError);
        })
        .then(function () {
          setButtonState(btn, failed ? null : 'done');
          if (!failed) {
            setTimeout(function () {
              setButtonState(btn, null);
            }, 1500);
          }
        });
    });
  }

  /* -------------------------------------------- 19. Tüm yorumlar sayfası */

  function initAllReviews() {
    var root = $('[data-all-reviews]');
    if (!root) return;
    // Theme editor bölümü yeniden yüklediğinde iki kez bağlanmayı önler
    if (root.dataset.ktBound === '1') return;
    root.dataset.ktBound = '1';

    var list = $('[data-list]', root);
    var moreBtn = $('[data-more]', root);
    var countEl = $('[data-count]', root);
    var sortSel = $('[data-sort]', root);
    var pageSize = parseInt(root.getAttribute('data-page-size'), 10) || 20;

    var all = [];
    var view = [];
    var shown = 0;
    var filter = 'all';

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function stars(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) out += i <= n ? '★' : '☆';
      return out;
    }

    function parseDate(d) {
      // gg.aa.yyyy
      var m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(d || '');
      return m ? new Date(+m[3], +m[2] - 1, +m[1]).getTime() : 0;
    }

    function applyFilterSort() {
      view = filter === 'all' ? all.slice() : all.filter(function (r) { return r.r === +filter; });
      var mode = sortSel ? sortSel.value : 'recent';
      view.sort(function (a, b) {
        if (mode === 'highest') return b.r - a.r || parseDate(b.d) - parseDate(a.d);
        if (mode === 'lowest') return a.r - b.r || parseDate(b.d) - parseDate(a.d);
        return parseDate(b.d) - parseDate(a.d);
      });
      shown = 0;
      list.innerHTML = '';
      render();
    }

    function render() {
      if (!view.length) {
        list.innerHTML = '<p style="grid-column:1/-1;color:var(--color-text-light)">' +
          esc(T.strings.noReviewsFilter || '') + '</p>';
        if (moreBtn) moreBtn.hidden = true;
        if (countEl) countEl.textContent = '';
        return;
      }

      var slice = view.slice(shown, shown + pageSize);
      var html = slice.map(function (r) {
        return (
          '<div class="review-card">' +
            '<div class="review-card__top">' +
              '<span class="review-card__stars">' + stars(r.r) + '</span>' +
              '<span class="review-card__date">' + esc(r.d) + '</span>' +
            '</div>' +
            '<div class="review-card__name">' + esc(r.n) +
              (r.v ? '<span class="review-card__verified">' + (T.strings.verified || '') + '</span>' : '') +
            '</div>' +
            '<div class="review-card__body">' + esc(r.t) + '</div>' +
          '</div>'
        );
      }).join('');

      list.insertAdjacentHTML('beforeend', html);
      shown += slice.length;

      if (moreBtn) moreBtn.hidden = shown >= view.length;
      if (countEl && T.strings.reviewsCountLine) {
        countEl.textContent = T.strings.reviewsCountLine
          .replace('__SHOWN__', shown)
          .replace('__TOTAL__', view.length);
      }
    }

    /** Puan, adet ve dağılımı yorum verisinden yeniden hesaplar. */
    function updateSummary() {
      if (!all.length) return;
      var sum = 0;
      var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      all.forEach(function (r) {
        sum += r.r;
        counts[r.r] = (counts[r.r] || 0) + 1;
      });

      var avg = Math.round((sum / all.length) * 10) / 10;
      var scoreEl = $('[data-summary-score]');
      if (scoreEl) scoreEl.textContent = String(avg).replace('.', ',');
      var countEl2 = $('[data-summary-count]');
      if (countEl2) countEl2.textContent = all.length;

      // Yüzdeler: en büyük kalan yöntemiyle toplam tam 100 olsun
      var exact = {}, floors = {}, used = 0;
      [1, 2, 3, 4, 5].forEach(function (s2) {
        exact[s2] = (counts[s2] * 100) / all.length;
        floors[s2] = Math.floor(exact[s2]);
        used += floors[s2];
      });
      [1, 2, 3, 4, 5]
        .sort(function (a, b) { return (exact[b] - floors[b]) - (exact[a] - floors[a]); })
        .slice(0, 100 - used)
        .forEach(function (s2) { floors[s2] += 1; });

      [1, 2, 3, 4, 5].forEach(function (s2) {
        var bar = $('[data-bar="' + s2 + '"]');
        var pct = $('[data-bar-pct="' + s2 + '"]');
        if (bar) bar.style.setProperty('--pct', floors[s2] + '%');
        if (pct) pct.textContent = '%' + floors[s2];
      });
    }

    on(moreBtn, 'click', render);
    on(sortSel, 'change', applyFilterSort);

    $$('[data-filter]', root).forEach(function (chip) {
      on(chip, 'click', function () {
        $$('[data-filter]', root).forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        filter = chip.getAttribute('data-filter');
        applyFilterSort();
      });
    });

    fetch(root.getAttribute('data-src'))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var handle = root.getAttribute('data-handle');
        all = (data && (data[handle] || data.default)) || [];
        updateSummary();
        applyFilterSort();
      })
      .catch(function () {
        list.innerHTML = '<p style="grid-column:1/-1;color:var(--color-text-light)">' +
          esc(T.strings.addToCartError || '') + '</p>';
      });
  }

  /* ------------------------------------------------------ 20. Video şeridi */

  function initVideoRow() {
    $$('[data-video-row]').forEach(function (row) {
      if (row.dataset.ktBound === '1') return;
      row.dataset.ktBound = '1';

      var track = $('[data-video-track]', row);
      var slides = $$('[data-video-slide]', row);
      var dots = $$('[data-video-dot]', row);
      var prev = $('[data-video-prev]', row);
      var next = $('[data-video-next]', row);
      if (!track || slides.length < 1) return;

      function current() {
        // Kaydırma konumundan aktif kartı bul
        var i = Math.round(track.scrollLeft / (slides[0].offsetWidth + gap()));
        return Math.max(0, Math.min(slides.length - 1, i));
      }

      function gap() {
        var g = parseFloat(getComputedStyle(track).columnGap);
        return isNaN(g) ? 0 : g;
      }

      function goTo(i) {
        // Döngüsel: sondan sonra başa, baştan geriye sona
        var n = slides.length;
        i = ((i % n) + n) % n;
        track.scrollTo({ left: i * (slides[0].offsetWidth + gap()), behavior: 'smooth' });
      }

      function sync() {
        var i = current();
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === i);
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        // Döngüsel olduğu için oklar hiç pasifleşmez
      }

      on(prev, 'click', function () { goTo(current() - 1); });
      on(next, 'click', function () { goTo(current() + 1); });
      dots.forEach(function (d, n) {
        on(d, 'click', function () { goTo(n); });
      });

      var ticking = false;
      on(track, 'scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          sync();
          ticking = false;
        });
      }, { passive: true });

      sync();

      // Ekranda olmayan videoyu durdur — veri ve pil harcamasın
      var videos = $$('video', row);
      if (!videos.length) return;

      var autoplay = row.getAttribute('data-autoplay') === 'true';

      if (!('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              if (autoplay && v.paused) {
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              }
            } else if (!v.paused) {
              v.pause();
            }
          });
        },
        { threshold: 0.5 }
      );
      videos.forEach(function (v) {
        v.muted = true;
        v.setAttribute('playsinline', '');
        io.observe(v);
      });
    });
  }

  /* ------------------------------------------------------------- başlat */

  function init() {
    initReveal();
    initMenu();
    CartDrawer.init();
    initGallery();
    initBundles();
    initSimpleProductForm();
    initStickyAtc();
    initLiveViewers();
    initCountdown();
    initBeforeAfter();
    initMiniReviews();
    initCollectionSort();
    initHeaderScroll();
    initSkeletons();
    initDeliveryEstimate();
    initLightbox();
    initQuickAdd();
    initAllReviews();
    initVideoRow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor uyumu
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);

  window.MoodmumTheme.formatMoney = formatMoney;
  window.MoodmumTheme.addToCart = addToCart;
  window.MoodmumTheme.CartDrawer = CartDrawer;
  window.MoodmumTheme.toast = toast;
})();
